import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faGithub, faLinkedin, faTwitter } from '@fortawesome/free-brands-svg-icons';

const SocialContainer = styled.div`
  display: flex;
  gap: 1.5rem;
  margin-top: 1rem;
`;

const SocialLink = styled.a`
  color: #333;
  font-size: 1.5rem;
  transition: color 0.3s ease;

  &:hover {
    color: #007bff;
  }
`;

function SocialLinks() {
  const socialLinks = [
    {
      icon: faGithub,
      url: 'https://github.com/kabilmbarki',
      label: 'GitHub'
    },
    {
      icon: faLinkedin,
      url: 'https://linkedin.com/in/kabil-mbarki',
      label: 'LinkedIn'
    },
    {
      icon: faFacebook,
      url: 'https://www.facebook.com/ka.bil.619348',
      label: 'Facebook'
    }
  ];

  return (
    <SocialContainer>
      {socialLinks.map((social, index) => (
        <SocialLink
          key={index}
          href={social.url}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={social.label}
        >
          <FontAwesomeIcon icon={social.icon} />
        </SocialLink>
      ))}
    </SocialContainer>
  );
}

export default SocialLinks;
